"use client";

import Spinner from "@/components/ui/Spinner";
import dynamic from "next/dynamic";
import { TAbout } from "./About";
import { useTranslations } from "next-intl";

const ReactPlayer = dynamic(() => import("react-player"), {
  ssr: false,
  loading: () => <Spinner className="w-14 h-14" />,
});

export default function IntroVideo({ video }: Partial<Pick<TAbout, "video">>) {
  const t = useTranslations();

  if (!video)
    return (
      <p className="text-muted-foreground text-center">{t("Coming Soon")}</p>
    );

  return (
    <ReactPlayer
      src={video}
      width="100%"
      height="100%"
      className="rounded-[5px]"
      controls
    />
  );
}
